import React from 'react';

import { Group, Skeleton, Title, useMantineTheme } from '@mantine/core';
import { UseQueryResult } from 'react-query';
import { PackageRetrieve } from 'types';
import { PackageTypeLabelsEnum } from 'types/enums';

import PackageDrawerState, { PackageType } from '../types';

interface IHeaderProps {
  packageHook: UseQueryResult<{
    data: PackageRetrieve;
  }>;
  state: PackageDrawerState;
  permission?: boolean;
  packageType?: PackageType;
}

const Header = ({ packageHook, state, packageType }: IHeaderProps): JSX.Element => {
  const theme = useMantineTheme();

  if (packageHook.isLoading) {
    return <Skeleton height={theme.fontSizes.xl} width={300} />;
  }

  let title: string = '';

  if (state === 'select-type') {
    title = 'Create Package';
  } else if (state === 'create-package' && packageType) {
    title = `Create Package | ${PackageTypeLabelsEnum[packageType]} Package`;
  } else if (state === 'create-billing' && packageType) {
    title = `${PackageTypeLabelsEnum[packageType]} Package - Configure Billing`;
  } else {
    title = 'Create Package';
  }

  if (
    (state === 'view-package' || state === 'edit-package' || state === 'edit-billing') &&
    packageHook.data?.data &&
    packageHook.isSuccess
  ) {
    title = `${packageHook.data.data.name} | ${PackageTypeLabelsEnum[packageHook.data.data.type]} Package`;
  }

  return (
    <Group>
      <Title order={3}>{title}</Title>
    </Group>
  );
};

export default Header;
